import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  cursor: pointer;
  gap: 0.5rem;
`;
